import { render, staticRenderFns } from "./PdfDropZone.vue?vue&type=template&id=5e1fb063&scoped=true"
import script from "./PdfDropZone.vue?vue&type=script&lang=js"
export * from "./PdfDropZone.vue?vue&type=script&lang=js"
import style0 from "./PdfDropZone.vue?vue&type=style&index=0&id=5e1fb063&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fb063",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1fb063')) {
      api.createRecord('5e1fb063', component.options)
    } else {
      api.reload('5e1fb063', component.options)
    }
    module.hot.accept("./PdfDropZone.vue?vue&type=template&id=5e1fb063&scoped=true", function () {
      api.rerender('5e1fb063', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/PdfDropZone.vue"
export default component.exports